import { TournamentSegmentBase } from "../TournamentSegment";
import { TournamentSegmentGroupBase } from "../TournamentSegmentGroup";

export type QualifierSegment = TournamentSegmentBase<"Qualifier", Qualifier>;

export type Qualifier = TournamentSegmentGroupBase & {
  matchIds: string[];
};

export const getQualifierMatchTitle = (
  qualifier: Qualifier,
  matchId: string
) => {
  if (qualifier.matchIds.includes(matchId)) {
    return qualifier.name;
  }

  return undefined;
};
